export var EOfferApplicationStage;
(function (EOfferApplicationStage) {
    EOfferApplicationStage["new"] = "new";
    EOfferApplicationStage["rejected"] = "rejected";
    EOfferApplicationStage["interview"] = "interview";
    EOfferApplicationStage["hired"] = "hired";
})(EOfferApplicationStage || (EOfferApplicationStage = {}));
